/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExecuteToolRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'
import {ExecuteToolResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tool_endpoint_messages.pb'


export const executeTool = (request: ExecuteToolRequest, options?: CashRequestOptions) => post<ExecuteToolRequest, ExecuteToolResponse>("/cash-app/goose-cash/v3/execute-tool", request, {...options, rejectOnError: true })